import {
  AppstoreOutlined,
  MailOutlined,
  CopyOutlined,
  SettingOutlined,
  UserOutlined,
  FileImageOutlined,
} from "@ant-design/icons";
const options = [
  // {
  //   key: "",
  //   label: "Kategoriler",
  //   leftIcon: <AppstoreOutlined />,
  // },
  {
    key: "manset",
    label: "Manşetler",
    leftIcon: <FileImageOutlined />,
  },
  {
    key: "icerikler",
    label: "İçerikler",
    leftIcon: <CopyOutlined />,
  },
  {
    key: "mesajlar",
    label: "E-posta",
    leftIcon: <MailOutlined />,
    children: [
      // {
      //   key: "e-posta/cevapla",
      //   label: "Yeni mesaj",
      // },
      {
        key: "e-posta/gelen-mesaj",
        label: "Gelen mesaj",
      },
      {
        key: "e-posta/giden-kutusu",
        label: "Gönderilenler",
      },
    ],
  },
  {
    key: "kullaniciler",
    label: "Kullanıcılar",
    leftIcon: <UserOutlined />,
  },
  {
    key: "ayarlar",
    label: "Ayarlar",
    leftIcon: <SettingOutlined />,
  },
  {
    key: "logs",
    label: "Log Kayıtları",
    leftIcon: <CopyOutlined />,
  },
];

export default options;
